module.exports = __webpack_public_path__ + "static/media/s_v10_12.f48edea1.mp3";